/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettingDto } from '../../models/setting-dto';

export interface SettingControllerFindByKey$Params {
  key: string;
}

export function settingControllerFindByKey(http: HttpClient, rootUrl: string, params: SettingControllerFindByKey$Params, context?: HttpContext): Observable<StrictHttpResponse<SettingDto>> {
  const rb = new RequestBuilder(rootUrl, settingControllerFindByKey.PATH, 'get');
  if (params) {
    rb.path('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettingDto>;
    })
  );
}

settingControllerFindByKey.PATH = '/api/setting/{key}';
